import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

export default function Shop () {
  const { t } = useTranslation('legals')

  return (
    <Box sx={{ border: '1px solid black', p: 2 }}>
      <h1>{t('shop.heading')}</h1>
    </Box>
  )
}
